import { UniswapToken } from '../interfaces'

export const sortTokens = (token0: UniswapToken, token1: UniswapToken): UniswapToken[] => {
  if (token0.address < token1.address) {
    return [token0, token1]
  }
  return [token1, token0]
}
